<div class="info-container">

  <div class="title" [innerHTML]="'Documents.DrivingLicense.Help.Title' | translate | safe:'html'">
  </div>

  <img src="/img/driving-license-example.png" alt="driving license example">

  <ul>
    <li [innerHTML]="'Documents.DrivingLicense.Help.File' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.DrivingLicense.Help.Valid' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.DrivingLicense.Help.Filled' | translate | safe:'html'"></li>
  </ul>

</div>
